'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isFunction;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isFunction.js
// module id = 813
// module chunks = 0